import { rem } from '../../../utils/rem';
import { balihai, catskill, endeavour, tundora, white } from '../colors';
export var MuiButton = {
    styleOverrides: {
        root: { borderRadius: 0 },
        contained: {
            color: endeavour,
            '&:disabled': {
                color: endeavour,
            },
        },
        containedPrimary: {
            color: white,
        },
        containedSecondary: {
            backgroundColor: catskill,
            border: "".concat(rem(1), " solid ").concat(balihai),
            color: tundora,
            '&:disabled': {
                backgroundColor: catskill,
                color: tundora,
            },
        },
    },
};
